import IOption from "../interfaces/IOption"
import Backend from "../utils/Backend"

export default function fetchColors(vehicle: any, success: (colors: IOption[]) => void, error: () => any) {
  let colorString = ""
  vehicle.colors.forEach((color: any) => {
    colorString += `${color.code},`
  })

  if (colorString === "") {
    error()
    return
  }
  
  colorString = colorString.substring(0, colorString.length - 1)

  Backend.getHexColours(vehicle.make, colorString).then(response => {
    return response.json()
  })
  .then(json => {
    // no colours were found
    if (Object.keys(json.paints).length === 0) {
      error()
      return
    }

    const paints = json.paints
    const processedColours: IOption[] = []

    const vehicleColours = vehicle.colors

    for (let colour of vehicleColours) {
      let colourLabel: string | undefined;
      let colorHex: string | undefined;
      let paintId: string | undefined;

      for (let prop in paints) {
        if (Object.prototype.hasOwnProperty.call(paints, prop)) {
          const codeToFind = colour.code.toLowerCase() 

          if (prop.toLowerCase() === codeToFind) {
            colourLabel = colour.name
            colorHex = paints[prop].primarySprayCan.primarySprayCanHighLightRGB.toLowerCase();
            paintId = paints[prop].paintId
            break;
          }
        }
      }

      if (!colourLabel || !colorHex || !paintId) continue // failed to find colour

      if (!colourLabel.toLowerCase().includes('(metallic)')) {
        const length = colourLabel.length;
        
        colourLabel = colourLabel.replace(/metallic/gi, "")
        
        if (colourLabel.length !== length) { // if updated try to remove comma and trim
          colourLabel = colourLabel.replaceAll(",", "").trim()
        }
      }

      processedColours.push({
        value: paintId + "&" + colourLabel, 
        label: colorHex,
      })
    }

    if (processedColours.length) success(processedColours)
    else error()
  })
  .catch((e) => {
    console.log('Failed to fetch colours')
    error()
  })
}